export const CONFIG_PRICING_LICENSE_TYPE = "config.pricing.licenseType";
export const CONFIG_PRICING_DEFAULT_INTERVAL = "config.pricing.defaultInterval";
export const CONFIG_PRICING_DEFAULT_CURRENCY = "config.pricing.defaultCurrency";
export const CONFIG_PRICING_EMPHASIS_INDEX = "config.pricing.emphasisIndex";

export const CONFIG_FEATURES_SHOW = "config.features.common.show";

export const ADMIN = "admin";
export const PRICE_DATA = "data.prices";
const MANIFEST_DATA = "manifest.data";
const THEME_DATA = "theme.data";

export const STATE_KEYS = {
  EDITOR: {
    INTENT: "editor.intent",
    VISIBILITY_PANEL: "editor.visibility.panel",
    ACTIVE_BLOCK: "editor.activeBlock",
    ACTIVE_SECTION: "editor.activeSection",
    PRICING: "editor.pricing",
    // Billing | Feature | Product Order
    PRICING_INTENT: "editor.pricing.intent",
    // > Product add | Price add
    PRODUCT_ORDER_INTENT: "editor.productOrder.intent",
    PRICING_ACTIVE_PRICE: "editor.pricing.activePrice",
    PRICING_ACTIVE_PRODUCT: "editor.pricing.activeProduct",
    // Product feature order
    FEATURE_INTENT: "editor.feature.intent",
    FEATURE_ACTIVE_PRODUCT: "editor.feature.activeProduct"
  },
  MANIFEST: {
    DATA: MANIFEST_DATA,
    ADMIN: `${MANIFEST_DATA}.${ADMIN}`,
    ADMIN_ACCOUNT: `${MANIFEST_DATA}.${ADMIN}.account`,
    CONFIG: `${MANIFEST_DATA}.config`,
    ENTITIES: `${MANIFEST_DATA}.entities`,
    LAYOUT: `${MANIFEST_DATA}.layout`,
    CONTENT: `${MANIFEST_DATA}.content`,
    PRICING_PRIMARIES: `${MANIFEST_DATA}.config.pricing.primaries`,
    PRICING_LAYOUT: `${MANIFEST_DATA}.config.pricing.layout`,
    PRICING_EMPHASIS_INDEX: `${MANIFEST_DATA}.${CONFIG_PRICING_EMPHASIS_INDEX}`,
    PRICING_DEFAULT_INTERVAL: `${MANIFEST_DATA}.${CONFIG_PRICING_DEFAULT_INTERVAL}`,
    PRICING_DEFAULT_CURRENCY: `${MANIFEST_DATA}.${CONFIG_PRICING_DEFAULT_CURRENCY}`,
    PRICING_LICENSE_TYPE: `${MANIFEST_DATA}.${CONFIG_PRICING_LICENSE_TYPE}`,
    FEATURES: `${MANIFEST_DATA}.config.features`,
    FEATURES_CLUSIVITY: `${MANIFEST_DATA}.config.features.common.clusivity`,
    FEATURES_SHOW: `${MANIFEST_DATA}.${CONFIG_FEATURES_SHOW}`,
    FEATURES_LIMIT: `${MANIFEST_DATA}.config.features.common.limit`,
    FEATURES_ORDER: `${MANIFEST_DATA}.config.features.common.order`,
    FEATURES_LAYOUT: `${MANIFEST_DATA}.config.features.common.layout`,
    FEATURE_GROUPS_LAYOUT: `${MANIFEST_DATA}.config.featureGroups.layout`
  },
  THEME: {
    DATA: THEME_DATA,
    FONT: `${THEME_DATA}.font`,
    FONT_FAMILY: `${THEME_DATA}.font.family`,
    COLOR_PRIMARY: `${THEME_DATA}.color.primary`,
    COLOR_SECONDARY: `${THEME_DATA}.color.secondary`,
    COLOR_HIGHLIGHT: `${THEME_DATA}.color.highlight`,
    TEXT_PRIMARY: `${THEME_DATA}.text.primary`,
    TEXT_SECONDARY: `${THEME_DATA}.text.secondary`
  },
  PRICE: {
    INTERVAL: "recurring.interval"
  },
  MERCHANT_ACCOUNT_CONFIG: {
    TRIAL_PERIOD_DAYS: "data.pricing.common.trial_period_days",
    SUCCESS_URL: "data.common.success_url",
    CANCEL_URL: "data.common.cancel_url"
  },
  ACCOUNT: {
    CHARGES_ENABLED: `account.chargesEnabled`
  },
  EVENT: {
    FULFILLMENT_STATUS: "data.fulfillment.status"
  },
  SHORT_LINK: {
    TITLE: "title",
    DESCRIPTION: "description",
    STATUS: "status",
    SUCCESS_URL: "data.success_url",
    CANCEL_URL: "data.cancel_url",
    PRIMARIES: "data.product.primaries",
    PRICES: "data.product.prices",
    ATTACHMENTS: "data.product.attachments",
    CHECKOUT: "data.product.checkout",
    DISCOUNTS: "data.product.checkout.discounts",
    TAX_RATES: "data.product.checkout.tax_rates",
    CUSTOMER_EMAIL: "data.product.checkout.customer_email",
    PAYMENT_METHOD_TYPES: "data.product.checkout.payment_method_types",
    SHIPPING_ADDRESS_COLLECTION:
      "data.product.checkout.shipping_address_collection",
    SHIPPING_ALLOWED_COUNTRIES:
      "data.product.checkout.shipping_address_collection.allowed_countries",
    SHIPPING_WORLDWIDE: "data.product.checkout.shipping_worldwide"
  },
  CAMPAIGN: {
    TITLE: "title",
    DESCRIPTION: "description",
    STATUS: "status",
    SUCCESS_URL: "data.success_url",
    CANCEL_URL: "data.cancel_url",
    RECEIVER: "data.receiver",
    DATASOURCES: "data.receiver.datasources",
    AUDIENCES: "data.receiver.audiences",
    PRIMARIES: "data.product.primaries",
    ATTACHMENTS: "data.product.attachments",
    CHECKOUT: "data.product.checkout",
    DISCOUNTS: "data.product.checkout.discounts",
    TAX_RATES: "data.product.checkout.tax_rates",
    CUSTOMER_EMAIL: "data.product.checkout.customer_email",
    PAYMENT_METHOD_TYPES: "data.product.checkout.payment_method_types",
    SHIPPING_ADDRESS_COLLECTION:
      "data.product.checkout.shipping_address_collection",
    SHIPPING_ALLOWED_COUNTRIES:
      "data.product.checkout.shipping_address_collection.allowed_countries",
    SHIPPING_WORLDWIDE: "data.product.checkout.shipping_worldwide"
  }
};
